import { render } from "./VistaEstadoCurso.vue?vue&type=template&id=15701fc0&scoped=true"
import script from "./VistaEstadoCurso.vue?vue&type=script&lang=js"
export * from "./VistaEstadoCurso.vue?vue&type=script&lang=js"

import "./VistaEstadoCurso.vue?vue&type=style&index=0&id=15701fc0&scoped=true&lang=css"

import exportComponent from "D:\\WEB\\LICEO\\CURSOS\\portalalumnoscursos\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15701fc0"]])

export default __exports__